import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useMemo, useRef } from 'react'

import { useFrame } from '../engine'
import { lerp, seg, smooth } from '../motion'
import { Check } from '../primitives'
import { useCopy } from './i18n'

/** Zählt im Bereich `at` bis `to`, mit Tausendertrennung der Sprache. */
export function Counter({ to, at, suffix = '', className }) {
  const { locale } = useCopy('ui')
  const ref = useRef(null)
  const format = useMemo(() => new Intl.NumberFormat(locale), [locale])
  useFrame((l) => {
    if (!ref.current) return
    const v = Math.round(lerp(0, to, smooth(seg(l, at[0], at[1]))))
    ref.current.textContent = `${format.format(v)}${suffix}`
  })
  return (
    <span ref={ref} className={className}>
      0{suffix}
    </span>
  )
}

Counter.propTypes = {
  to: PropTypes.number.isRequired,
  at: PropTypes.arrayOf(PropTypes.number).isRequired,
  suffix: PropTypes.string,
  className: PropTypes.string
}

/** Siegel-Zeile wie auf dem Deck-Cover (DIN 33430, EU AI Act, Frankfurt). */
export function Badges({ items, light = false, className, style }) {
  return (
    <div
      className={clsx('uc-badges', light && 'uc-badges--light', className)}
      style={style}
    >
      {items.map((b) => (
        <span key={b} className='uc-badge'>
          <Check size={18} color='green' />
          {b}
        </span>
      ))}
    </div>
  )
}

Badges.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  light: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
}

/** Endlos laufende Logoleiste, steht bei reduzierter Bewegung still. */
export function Marquee({ logos, className }) {
  const row = logos.map(([name, src]) => (
    <span key={name} className='uc-marquee__logo'>
      <img src={src} alt={name} />
    </span>
  ))
  return (
    <div className={clsx('uc-marquee', className)}>
      <div className='uc-marquee__track'>
        {row}
        <span className='uc-marquee__dup' aria-hidden='true'>
          {row}
        </span>
      </div>
    </div>
  )
}

Marquee.propTypes = {
  logos: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  className: PropTypes.string
}

export const toTop = () => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' })
}
